
import { Options, Vue } from 'vue-class-component'
import draggable from 'vuedraggable'
import { Prop } from 'vue-property-decorator'
import { calcOrderingDragend } from '@/utils/helpers'
import { maska } from 'maska'

@Options({
  components: { draggable },
  directives: { maska },
  emits: ['update:modelValue', 'update:quantityItem'],
})
export default class FormLIFFOption extends Vue {
  @Prop({ default: [] })
  modelValue!: string[]

  @Prop()
  isDeleteFirst!: boolean

  @Prop({ default: 'select' })
  optionType!: string

  countAnswer = 0
  currentAnswer = ''

  get value() {
    return this.modelValue
  }

  set value(value: string[]) {
    this.$emit('update:modelValue', value)
  }

  get requiredRule() {
    return {
      fieldName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.form.field_name'),
      }),
    }
  }

  handleAddAnswer() {
    const trimmed = this.currentAnswer.trim()
    if (!trimmed) return

    const newValue = [...this.value, trimmed]
    this.value = newValue

    this.currentAnswer = ''

    if (newValue.length === 1) {
      this.$emit('update:quantityItem', newValue.length)
    }
  }

  handleDeleteAnswer(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
      this.countAnswer = index - 1
    }

    if (this.value.length === 0) {
      this.$emit('update:quantityItem', this.value.length)
    }
  }

  async onDragEnd(evt: any, finalList: string[]) {
    if (!evt.moved) {
      return
    }

    const record = evt.moved.element
    calcOrderingDragend(record, finalList)
  }
}
